/**
 * @file 校区管理页 · 表单类型
 * @description 新建 / 编辑校区弹窗的表单值。
 *
 * @whenToUse 仅校区管理页。
 * @whenNotToUse 其他业务模块。
 */

/** 新建 / 编辑校区表单值 */
export type CampusFormValues = {
  /** 校区名称 */
  campusName: string
  /** 主账号 */
  userName: string
  /** 主账号密码；新建可空（默认 123456），编辑留空表示不改 */
  password: string
  /** 点数 */
  points: number
}

/** 空表单默认值 */
export const EMPTY_CAMPUS_FORM: CampusFormValues = {
  campusName: '',
  userName: '',
  password: '',
  points: 0,
}
